import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { CloseBtnModule } from './../common/close-btn/close-btn.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../shared/shared.module';
import { StoryRoutingModule } from './story-routing.module';
import {
  MainComponent, StoryTabsComponent, StoryTabComponent, UpdatesTabComponent, UtmPopupComponent
} from './components';
import { MatExpansionModule } from '@angular/material/expansion';
import { BannerModule } from '../common/banner/banner.module';
import { BenficiaryCardModule } from '../common/benficiary-card/benficiary-card.module';
import { ButtonModule } from '../common/button/button.module';
import { ContactDialogModule } from '../common/contact-dialog/contact-dialog.module';
import { DocumentModule } from '../common/document/document.module';
import { DonateNowModule } from '../common/donate-now/donate-now.module';
import { DonationMethodsModule } from '../common/donation-methods/donation-methods.module';
import { EndFundraiserBannerModule } from '../common/end-fundraiser-banner/end-fundraiser-banner.module';
import { FbShareModule } from '../common/fb-share/fb-share.module';
import { InnerTemplaterModule } from '../common/inner-templater/inner-templater.module';
import { ModuleLoaderModule } from '../common/module-loader/module-loader.module';
import { PaymentModule } from '../common/payment/payment.module';
import { PlaceholderLoaderModule } from '../common/placeholder-loader/placeholder-loader.module';
import { SocialShareBtnModule } from '../common/social-share-btn/social-share-btn.module';
import { SocialShareModule } from '../common/social-share/social-share.module';
import { WhatsappShareModule } from '../common/whatsapp-share/whatsapp-share.module';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { HospitalDoctorContactModule } from '../common/hospital-doctor-contact/hospital-doctor-contact.module';
import { SupportCardModule } from '../common/support-card/support-card.module';
import { StoryDocsModule } from '../common/story-docs/story-docs.module';
import { SocialNumberModule } from '../common/social-number/social-number.module';
import { CopyrightFooterComponent } from '../common/copyright-footer/copyright-footer.component';

/**Story components */
const StoryComponents = [
  MainComponent, StoryTabsComponent, StoryTabComponent, UpdatesTabComponent, UtmPopupComponent
];
/** Internal Modules */
const AppModules = [
  SharedModule, StoryRoutingModule, SupportCardModule,
  InnerTemplaterModule, DonationMethodsModule,
  ButtonModule, FbShareModule, WhatsappShareModule,
  DonateNowModule, ContactDialogModule, EndFundraiserBannerModule,
  PlaceholderLoaderModule, SocialShareBtnModule,SocialShareModule,
  BannerModule, BenficiaryCardModule, ModuleLoaderModule,
  PaymentModule, DocumentModule, CloseBtnModule, StoryDocsModule, DonationMethodsModule
];
@NgModule({
  imports: [
    CommonModule,
    MatTabsModule,
    MatBottomSheetModule,
    MatExpansionModule,
    ...AppModules,
    MatButtonModule,
    MatRippleModule,
    MatExpansionModule,
    MatTabsModule,
    HospitalDoctorContactModule,
    SocialNumberModule,
    CopyrightFooterComponent
  ],
  declarations: [
    ...StoryComponents,
    UtmPopupComponent,
  ],
})
export class StoryModule { }
